import { ssnFieldManagerConfigDefaults } from './types.js';
export const ssnMaskPattern = /^\d{3}-?\d{2}-?\d{4}$/;
export const ssnRegex = /^(?!666|000|9\d{2})\d{3}?(-)(?!00)\d{2}?(-)(?!0{4})\d{4}$/;
export function matchValueInString(value, searchValue, startPos = 0, endPos = Infinity) {
    return value.slice(startPos, endPos).match(new RegExp(`${searchValue}`, 'g'));
}
export function spliceCharactersIntoString(value, newCharacters = '', startIndex = 0, deleteCount = 0) {
    const splitString = value.split('');
    const args = newCharacters.split('');
    splitString.splice(startIndex, deleteCount, ...args);
    return splitString.join('');
}
/**
 * @param {number} selectionStart - starting cursor position from highlighted selection
 * @param {number} selectionEnd - ending cursor position from highlighted selection
 * @param {string} previousInputValue - formatted/unformatted input value 333-22-4444
 * @param {string} realValue - unformatted realized ssn value 333224444
 * @param {string} [insertValue=''] - value to replace selected range
 * @param {'insert'|'delete'} [mode='delete'] - inserting or deleting from realValue
 * @param {string} [separator='-'] - symbol that is used to separate ssn section (-)
 *
 * @return {string} value after deleting characters from selection range
 *
 * @description allows user to delete characters from input value ignoring separators
 */
export function modifySelectedRangeOfSsnValue(selectionStart, selectionEnd, previousInputValue, realValue, insertValue = '', mode = 'delete', separator = ssnFieldManagerConfigDefaults.separator) {
    let spliceStartIndex = selectionStart;
    let spliceDeleteCount = selectionEnd - selectionStart;
    const hasSeparatorsInUnselectedRange = matchValueInString(previousInputValue, separator, 0, selectionStart);
    // if value has separators in unselected range subtract the number of separators from spliceStartIndex
    if (hasSeparatorsInUnselectedRange) {
        spliceStartIndex = selectionStart - hasSeparatorsInUnselectedRange.length;
    }
    // no selection range, deleting 1 character
    if (spliceDeleteCount === 0 && mode === 'delete') {
        // if deleting a separator return without deleting anything from realValue
        if ([4, 7].includes(selectionStart) && hasSeparatorsInUnselectedRange) {
            return realValue;
        }
        spliceStartIndex = spliceStartIndex - 1;
        spliceDeleteCount = 1;
    }
    if (spliceDeleteCount > 0) {
        // modifying a selected range of characters
        const hasSeparatorsInPreviousMarkedValue = matchValueInString(previousInputValue, separator, selectionStart, selectionEnd);
        // if selected characters is formatted subtract the number of separators from spliceDeleteCount
        if (hasSeparatorsInPreviousMarkedValue) {
            spliceDeleteCount = spliceDeleteCount - hasSeparatorsInPreviousMarkedValue.length;
        }
    }
    return spliceCharactersIntoString(realValue, insertValue, spliceStartIndex, spliceDeleteCount);
}
export function maskFirstFiveNumbers(unmaskedString, maskCharactersWith = ssnFieldManagerConfigDefaults.maskedCharacter) {
    const stringAsArray = unmaskedString.split('');
    let counter = 0;
    for (let i = 0; i < stringAsArray.length; i += 1) {
        if (counter > 4) {
            break;
        }
        const characterIsANumber = !isNaN(+stringAsArray[i]);
        if (characterIsANumber) {
            stringAsArray[i] = maskCharactersWith;
            counter += 1;
        }
    }
    return stringAsArray.join('');
}
// TODO: fix bug, will not format a number that has more than 9 numbers correctly
export function formatSSN(value, config = ssnFieldManagerConfigDefaults) {
    const { maskedCharacter, separator } = { ...ssnFieldManagerConfigDefaults, ...config };
    const cleanValue = value.replace(/\D/g, ''); // \D any none digit
    const { length } = cleanValue;
    let formattedValue = '';
    let maskedValue = '';
    if (length >= 10) {
        formattedValue = cleanValue.slice(0, 11).replace(/(\d{3})(\d{3})(\d{4})/, `$1${separator}$2${separator}$3`);
    }
    else if (length >= 5) {
        formattedValue = cleanValue.replace(/(\d{3})(\d{2})(\d*)/, `$1${separator}$2${separator}$3`);
    }
    else if (length >= 3) {
        formattedValue = cleanValue.replace(/(\d{3})(\d*)/, `$1${separator}$2`);
    }
    else {
        formattedValue = cleanValue;
    }
    maskedValue = formattedValue;
    formattedValue.split('-').forEach((section, index) => {
        if (index < 2) {
            maskedValue = maskedValue.replace(section, ''.padEnd(section.length, maskedCharacter));
        }
    });
    return {
        formattedValue,
        maskedValue
    };
}
//# sourceMappingURL=ssn-utils.js.map